import { useState, useEffect } from "react";
import { CARD2, BD, TX, TX2, GR, BL, YL, RD } from "../../utils/constants";
import PredictTab from "../Predict/PredictTab";

export default function SettingsDrawer({
  settingsOpen, setSettingsOpen,
  user,
  topN, setTopN,
  sortBy, setSortBy,
  autoScan, setAutoScan,
  autoInterval, setAutoInterval,
  onLogout,
  onExportCSV,
  isPro,
  subscription,
  paymentUrl,
  onSubscribe,
  onActivateDemo,
  onClearSubscription,
  predLog,
}) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  if (!settingsOpen) return null;
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 400 }} onClick={() => setSettingsOpen(false)}>
      <div
        className="ts-panel"
        style={{
          position: "absolute", right: 0, top: 0, bottom: 0, width: isMobile ? "100vw" : 320,
          background: "rgba(10,16,32,0.98)", borderLeft: `1px solid ${BD}`,
          display: "flex", flexDirection: "column",
          animation: "slideIn 0.2s ease-out", overflow: "hidden",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: "16px 20px 14px", borderBottom: `1px solid ${BD}`, display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
          <span style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 800, fontSize: 14, color: TX }}>Settings</span>
          <button className="btn" onClick={() => setSettingsOpen(false)} style={{ background: CARD2, border: `1px solid ${BD}`, borderRadius: 6, padding: "4px 10px", color: TX2, fontSize: 11 }}>✕</button>
        </div>

        <div style={{ flex: 1, overflowY: "auto", padding: "8px 0" }}>

          {/* Account */}
          <div style={{ padding: "12px 20px 8px" }}>
            <div style={{ fontSize: 7, color: TX2, letterSpacing: 3, marginBottom: 12 }}>ACCOUNT</div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 14px", background: CARD2, border: `1px solid ${BD}`, borderRadius: 10, marginBottom: 10 }}>
              <div style={{ width: 36, height: 36, borderRadius: "50%", background: `linear-gradient(135deg,${GR},${BL})`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 15, fontWeight: 800, color: "#000", flexShrink: 0 }}>
                {user?.displayName?.[0]?.toUpperCase() || "U"}
              </div>
              <div>
                <div style={{ fontSize: 11, fontWeight: 600, color: TX }}>{user?.displayName}</div>
                <div style={{ fontSize: 9, color: TX2, marginTop: 2 }}>{user?.email}</div>
              </div>
            </div>
            <div style={{ background: CARD2, border: `1px solid ${isPro ? GR + "45" : YL + "35"}`, borderRadius: 10, padding: "11px 13px", marginBottom: 10 }}>
              <div style={{ display: "flex", justifyContent: "space-between", gap: 8, alignItems: "center", marginBottom: 8 }}>
                <div>
                  <div style={{ fontSize: 8, color: TX2, letterSpacing: 2, marginBottom: 3 }}>BILLING</div>
                  <div style={{ fontSize: 12, color: isPro ? GR : YL, fontWeight: 800 }}>{isPro ? "ACCESS ACTIVE" : "ACCESS REQUIRED"}</div>
                </div>
                <div style={{ fontSize: 8, color: TX2, textAlign: "right" }}>{subscription?.plan || "Free"}</div>
              </div>
              {isPro && (
                <div style={{ fontSize: 9, color: TX2, marginBottom: 8 }}>No payment required — full access is free.</div>
              )}
              <button className="btn" onClick={onSubscribe} style={{ width: "100%", background: isPro ? CARD2 : `linear-gradient(135deg,${GR},${BL})`, border: `1px solid ${isPro ? BD : "transparent"}`, borderRadius: 8, padding: "8px", color: isPro ? TX2 : "#000", fontSize: 9, fontWeight: 800 }}>
                {isPro ? "MANAGE BILLING" : "SUBSCRIBE"}
              </button>
              {!isPro && (
                <button className="btn" onClick={onActivateDemo} style={{ width: "100%", marginTop: 6, background: CARD2, border: `1px solid ${BD}`, borderRadius: 8, padding: "8px", color: TX2, fontSize: 9 }}>
                  LOCAL DEMO UNLOCK
                </button>
              )}
              {isPro && subscription?.source === "local-demo" && (
                <button className="btn" onClick={onClearSubscription} style={{ width: "100%", marginTop: 6, background: RD + "12", border: `1px solid ${RD}35`, borderRadius: 8, padding: "8px", color: RD, fontSize: 9 }}>
                  RESET DEMO ACCESS
                </button>
              )}
            </div>
            <button className="btn" onClick={() => { onLogout(); setSettingsOpen(false); }} style={{ width: "100%", background: CARD2, border: `1px solid ${RD}30`, borderRadius: 8, padding: "9px", color: RD, fontSize: 9, letterSpacing: 1 }}>SIGN OUT</button>
          </div>

          <div style={{ height: 1, background: BD, margin: "4px 20px 4px" }} />

          {/* Scan */}
          <div style={{ padding: "12px 20px 8px" }}>
            <div style={{ fontSize: 7, color: TX2, letterSpacing: 3, marginBottom: 12 }}>SCAN</div>
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 8, color: TX2, letterSpacing: 1, marginBottom: 6 }}>TOP PICKS TO DISPLAY</div>
              <div style={{ display: "flex", gap: 6 }}>
                {[3, 5, 10].map((n) => (
                  <button key={n} className="btn" onClick={() => setTopN(n)} style={{ flex: 1, background: topN === n ? GR+"18" : CARD2, border: `1px solid ${topN === n ? GR+"60" : BD}`, borderRadius: 8, padding: "9px", color: topN === n ? GR : TX2, fontSize: 13, fontWeight: 700 }}>{n}</button>
                ))}
              </div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 8, color: TX2, letterSpacing: 1, marginBottom: 6 }}>SORT TABLE BY</div>
              <select value={sortBy} onChange={(e) => setSortBy(e.target.value)} style={{ width: "100%", background: CARD2, border: `1px solid ${BD}`, borderRadius: 8, padding: "9px 12px", color: TX, fontSize: 11 }}>
                <option value="score">Score</option>
                <option value="change">Today %</option>
                <option value="5d">5-Day %</option>
                <option value="symbol">A-Z</option>
              </select>
            </div>
            <div style={{ marginBottom: 4 }}>
              <div style={{ fontSize: 8, color: TX2, letterSpacing: 1, marginBottom: 6 }}>AUTO SCAN</div>
              <div style={{ display: "flex", gap: 6 }}>
                <button className="btn" onClick={() => setAutoScan(!autoScan)} style={{ flex: 1, background: autoScan ? GR+"18" : CARD2, border: `1px solid ${autoScan ? GR+"60" : BD}`, borderRadius: 8, padding: "9px", color: autoScan ? GR : TX2, fontSize: 10, fontWeight: 700 }}>{autoScan ? "ON" : "OFF"}</button>
                <select value={autoInterval} onChange={(e) => setAutoInterval(Number(e.target.value))} style={{ flex: 1, background: CARD2, border: `1px solid ${BD}`, borderRadius: 8, padding: "9px 8px", color: TX, fontSize: 10 }}>
                  {[5,10,15,30].map((v) => <option key={v} value={v}>{v} min</option>)}
                </select>
              </div>
            </div>
          </div>

          <div style={{ height: 1, background: BD, margin: "4px 20px 4px" }} />

          {/* Data / Export */}
          <div style={{ padding: "12px 20px 8px" }}>
            <div style={{ fontSize: 7, color: TX2, letterSpacing: 3, marginBottom: 12 }}>DATA</div>
            <button className="btn" onClick={onExportCSV} style={{ width: "100%", background: CARD2, border: `1px solid ${BD}`, borderRadius: 8, padding: "9px", color: TX2, fontSize: 9 }}>Export CSV</button>
          </div>

          <div style={{ height: 1, background: BD, margin: "4px 20px 4px" }} />

          {/* Signals */}
          <div style={{ padding: "12px 20px 8px" }}>
            <div style={{ fontSize: 7, color: TX2, letterSpacing: 3, marginBottom: 12 }}>SIGNALS</div>
            <PredictTab predLog={predLog} />
          </div>
        </div>
      </div>
    </div>
  );
}
